import { useState } from "react";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  const [activeId, setActiveId] = useState<string | null>(null);
  const active = categories.find((item) => item.id === activeId);

  return (
    <section id="categories" className="w-full border-b border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-widest text-accent-700">分类专区</span>
            <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              按题材归好，先划范围再挑
            </h2>
          </div>
          <p className="text-xs text-foreground-600">
            {active ? `已选：${active.name} · ${active.count} 个入口` : "点一下分类查看该题材下的入口数量"}
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
          {categories.map((item) => {
            const isActive = item.id === activeId;
            return (
              <button
                key={item.id}
                type="button"
                onClick={() => setActiveId(isActive ? null : item.id)}
                className={`flex cursor-pointer flex-col items-start gap-2 rounded-md border p-3 text-left transition-colors ${
                  isActive
                    ? "border-primary-400 bg-primary-50"
                    : "border-background-200 bg-background-50 hover:border-accent-300 hover:bg-accent-50"
                }`}
              >
                <span
                  className={`flex h-8 w-8 items-center justify-center rounded-md ${
                    isActive ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-700"
                  }`}
                >
                  <i className={`${item.icon} text-base`} />
                </span>
                <span className="font-heading text-sm font-bold text-foreground-950">{item.name}</span>
                <span className="flex w-full items-center justify-between text-[11px] text-foreground-500">
                  <span>{item.note}</span>
                  <span className="text-foreground-800">{item.count}</span>
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}